var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initBundle = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const random_id = utils.shortUUID();
  const preorder_threshold = +((_a = window.theme_settings.data__product__variant__preorder_threshold) != null ? _a : 1);
  const bundle_products = (_b = [...$el.querySelectorAll("[data-product-handle][data-product-id]")]) == null ? void 0 : _b.map((element) => ({
    element,
    ..._product.getHtmlProduct(element.getAttribute("data-product-handle"))
  }));
  const section_settings = utils.JSONParse($el.getAttribute("data-section-settings"));
  const select_settings = utils.JSONParse(
    (_c = $el.querySelector("[data-select-settings]")) == null ? void 0 : _c.getAttribute("data-select-settings")
  );
  const select_type = (_d = select_settings == null ? void 0 : select_settings.type) != null ? _d : "auto";
  const bundle_targets = [...(_e = $el.querySelectorAll("[data-bundle-target]")) != null ? _e : []].map(
    (el) => utils.JSONParse(
      el.getAttribute("data-bundle-target")
    )
  );
  const initial_bundle_target_id = (_f = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _f.id;
  const initial_target = {
    ...bundle_targets == null ? void 0 : bundle_targets[0]
  };
  bundle_targets == null ? void 0 : bundle_targets.sort((a, b) => {
    var _a2, _b2;
    return ((_a2 = a.settings) == null ? void 0 : _a2.target) - ((_b2 = b == null ? void 0 : b.settings) == null ? void 0 : _b2.target);
  });
  const bundle_target_objects = bundle_targets == null ? void 0 : bundle_targets.reduce((acc, item, i) => {
    acc[item.id] = item.settings;
    return acc;
  }, {});
  const incentive_targets = [...(_g = $el.querySelectorAll("[data-bundle-incentive-target]")) != null ? _g : []].map(
    (el) => utils.JSONParse(el.getAttribute("data-bundle-incentive-target"))
  );
  const bundle_type = section_settings.bundle_target_type;
  const addToBundle = /* @__PURE__ */ __name(({
    product,
    variant,
    price
  }) => {
    var _a2, _b2, _c2;
    if ((variant == null ? void 0 : variant.inventory_management) && (variant == null ? void 0 : variant.inventory_policy) !== "continue") {
      const quantity_added = state.items_added.reduce((acc, item) => {
        var _a3;
        if (((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === variant.id) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (variant.inventory_quantity - quantity_added < 1) {
        _stores.toast.addToast({
          type: "error",
          title: "Not enough inventory",
          content: "It looks like you already added the item and the inventory limit has been reached."
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "hard_limit") {
      if ((state == null ? void 0 : state[bundle_type]) < ((_a2 = state.bundle_target) == null ? void 0 : _a2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      }
      return;
    }
    if (section_settings.restrict_bundle_quantity === "upgrade_limit") {
      const lastBundleTarget = (_b2 = [...bundle_targets].sort((a, b) => {
        var _a3, _b3;
        return ((_a3 = a == null ? void 0 : a.settings) == null ? void 0 : _a3.target) - ((_b3 = b == null ? void 0 : b.settings) == null ? void 0 : _b3.target);
      })) == null ? void 0 : _b2.at(-1);
      if ((state == null ? void 0 : state[bundle_type]) < ((_c2 = lastBundleTarget == null ? void 0 : lastBundleTarget.settings) == null ? void 0 : _c2.target)) {
        state.items_added.push({ product, variant, price_override: price });
      } else {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!"
        });
        return;
      }
    }
    if (section_settings.restrict_bundle_quantity === "no_limit") {
      state.items_added.push({ product, variant, price_override: price });
    }
    updateBundleById();
  }, "addToBundle");
  const removeFromBundle = /* @__PURE__ */ __name(({
    product,
    variant
  }) => {
    var _a2;
    const index = (_a2 = state.items_added) == null ? void 0 : _a2.findLastIndex((item) => {
      var _a3;
      return ((_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id) === (variant == null ? void 0 : variant.id) && item.product.id === product.id;
    });
    state.items_added.splice(index, 1);
  }, "removeFromBundle");
  const state = window.Alpine.reactive({
    items_added: [],
    bundle_target_titles: [],
    item_added_summary: [],
    bundle_target_id: initial_bundle_target_id,
    total_price: 0,
    discounted_price: 0,
    current_wording: "",
    difference_wording: "",
    target_wording: "",
    final_price: 0,
    before_discounts_price: 0,
    target_discount_wording: "",
    active_target_discount_wording: "",
    discount_wording: "",
    active_discount_wording: "",
    item_count: 0,
    target_difference: "",
    bundle_target: initial_target == null ? void 0 : initial_target.settings,
    achieved_bundle_target: null,
    incentive_target: incentive_targets == null ? void 0 : incentive_targets[0],
    isAdding: false,
    items_added_to_cart: false,
    show_mobile_details: false,
    addToBundle,
    removeFromBundle
  });
  const getTargetTitles = /* @__PURE__ */ __name(() => {
    return bundle_targets == null ? void 0 : bundle_targets.map((item) => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
      const lowestPrice = Math.min(...bundle_products.map((product) => product.price_min));
      const highestPrice = Math.max(...bundle_products.map((product) => {
        var _a3;
        return (_a3 = product.price_max) != null ? _a3 : product.price;
      }));
      const priceVaries = ((state == null ? void 0 : state.final_price) || lowestPrice) !== ((state == null ? void 0 : state.total_price) || highestPrice);
      return ((_a2 = item.label) == null ? void 0 : _a2.trim()) ? `<span class="flex gap-2 w-full items-center">${utils.unescape(
        (_h = item.label) == null ? void 0 : _h.replace(
          "[price]",
          `<span>${utils.formatMoney(
            (state == null ? void 0 : state.final_price) || (lowestPrice - ((_c2 = (_b2 = item == null ? void 0 : item.settings) == null ? void 0 : _b2.discount_percentage) != null ? _c2 : 0) / 100 * lowestPrice - ((_e2 = (_d2 = item == null ? void 0 : item.settings) == null ? void 0 : _d2.discount_amount) != null ? _e2 : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_f2 = item.settings) == null ? void 0 : _f2.target : 1)
          )}</span>`
        ).replace(
          "[compare_at_price]",
          `<span class="opacity-50 line-through">${utils.formatMoney(
            (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_g2 = item.settings) == null ? void 0 : _g2.target : 1)
          )}</span>`
        )
      )}</span>` : (_z = `<span class="flex items-center gap-2">
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "total_price" && ((_i = item.settings) == null ? void 0 : _i.target) ? `<span>Spend ${utils.formatMoney((_j = item.settings) == null ? void 0 : _j.target)}</span>` : ""}
       ${(section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? `<span>${(_k = item.settings) == null ? void 0 : _k.target} ${((_l = item.settings) == null ? void 0 : _l.target) === 1 ? "item" : "items"}</span>` : ""}
       ${((_m = item == null ? void 0 : item.settings) == null ? void 0 : _m.discount_percentage) > 0 && ((_n = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _n.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${(_o = item == null ? void 0 : item.settings) == null ? void 0 : _o.discount_percentage}% off</span>` : ""}
       ${((_p = item == null ? void 0 : item.settings) == null ? void 0 : _p.discount_amount) > 0 && ((_q = select_settings == null ? void 0 : select_settings.discount_label) == null ? void 0 : _q.trim()) ? `<span class="${select_settings == null ? void 0 : select_settings.discount_label}">${utils.formatMoney(
        (_r = item == null ? void 0 : item.settings) == null ? void 0 : _r.discount_percentage
      )} off</span>` : ""}
       ${(select_settings == null ? void 0 : select_settings.price_content) ? `<span class="flex-1 flex justify-end gap-2">
           ${(_y = select_settings == null ? void 0 : select_settings.price_content) == null ? void 0 : _y.replace(
        "[price]",
        `<span>${utils.formatMoney(
          (state == null ? void 0 : state.final_price) || (lowestPrice - ((_t = (_s = item == null ? void 0 : item.settings) == null ? void 0 : _s.discount_percentage) != null ? _t : 0) / 100 * lowestPrice - ((_v = (_u = item == null ? void 0 : item.settings) == null ? void 0 : _u.discount_amount) != null ? _v : 0)) * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_w = item.settings) == null ? void 0 : _w.target : 1)
        )}</span>`
      ).replace(
        "[compare_at_price]",
        priceVaries ? `<span class="opacity-50 line-through">${utils.formatMoney(
          (state == null ? void 0 : state.total_price) || lowestPrice * ((section_settings == null ? void 0 : section_settings.bundle_target_type) === "item_count" ? (_x = item.settings) == null ? void 0 : _x.target : 1)
        )}</span>` : ""
      )}` : ""}
      </span>`) == null ? void 0 : _z.replace(/\n/gi, "").trim();
    });
  }, "getTargetTitles");
  state.bundle_target_titles = getTargetTitles();
  window.Alpine.effect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
    state.item_count = (_a2 = state.items_added) == null ? void 0 : _a2.length;
    state.total_price = state.items_added.reduce((acc, item) => {
      var _a3, _b3;
      return acc += (_b3 = item == null ? void 0 : item.price_override) != null ? _b3 : (_a3 = item.variant) == null ? void 0 : _a3.price;
    }, 0);
    state.achieved_bundle_target = (_c2 = (_b2 = [...bundle_targets].sort((a, b) => {
      var _a3, _b3;
      return ((_a3 = b.settings) == null ? void 0 : _a3.target) - ((_b3 = a == null ? void 0 : a.settings) == null ? void 0 : _b3.target);
    })) == null ? void 0 : _b2.find((bundle) => bundle.settings.target <= (state == null ? void 0 : state[bundle_type]))) == null ? void 0 : _c2.settings;
    if (select_type === "auto") {
      state.bundle_target = (_d2 = [...bundle_targets].sort((a, b) => {
        var _a3, _b3;
        return ((_a3 = a.settings) == null ? void 0 : _a3.target) - ((_b3 = a == null ? void 0 : a.settings) == null ? void 0 : _b3.target);
      }).find((bundle) => bundle.settings.target > (state == null ? void 0 : state[bundle_type]))) == null ? void 0 : _d2.settings;
    }
    state.discounted_price = state.total_price - ((_f2 = (_e2 = state.achieved_bundle_target) == null ? void 0 : _e2.discount_amount) != null ? _f2 : 0) - state.total_price * (((_h = (_g2 = state == null ? void 0 : state.achieved_bundle_target) == null ? void 0 : _g2.discount_percentage) != null ? _h : 0) / 100);
    state.before_discounts_price = state.total_price;
    state.final_price = state.discounted_price;
    state.target_difference = bundle_type === "item_count" ? ((_i = state.bundle_target) == null ? void 0 : _i.target) - state.item_count > 0 ? `${((_j = state.bundle_target) == null ? void 0 : _j.target) - state.item_count}` : "" : ((_k = state.bundle_target) == null ? void 0 : _k.target) - state.total_price ? `${utils.formatMoney(((_l = state.bundle_target) == null ? void 0 : _l.target) - state.item_count)}` : "";
    state.target_wording = bundle_type === "item_count" ? `${(_m = state.bundle_target) == null ? void 0 : _m.target}` : utils.formatMoney((_n = state.bundle_target) == null ? void 0 : _n.target);
    state.current_wording = bundle_type === "item_count" ? `${state.item_count}` : utils.formatMoney(state.total_price);
    state.difference_wording = bundle_type === "item_count" ? `${((_o = state.bundle_target) == null ? void 0 : _o.target) - state.item_count}` : utils.formatMoney(((_p = state.bundle_target) == null ? void 0 : _p.target) - state.total_price);
    state.target_discount_wording = ((_q = state.bundle_target) == null ? void 0 : _q.discount_amount) ? `Save ${utils.formatMoney((_r = state.bundle_target) == null ? void 0 : _r.discount_amount)}` : ((_s = state == null ? void 0 : state.bundle_target) == null ? void 0 : _s.discount_percentage) ? `${(_t = state == null ? void 0 : state.bundle_target) == null ? void 0 : _t.discount_percentage}% off` : "";
    state.discount_wording = `${utils.roundToIndex((1 - state.final_price / state.total_price) * 100, 0)}% off`;
    state.active_target_discount_wording = state.total_price > state.final_price ? state.target_discount_wording : "";
    state.active_discount_wording = state.total_price > state.final_price ? state.discount_wording : "";
    state.item_added_summary = (_u = state == null ? void 0 : state.items_added) == null ? void 0 : _u.reduce((acc, item) => {
      var _a3, _b3;
      const addedIndex = acc.findIndex((item2) => {
        var _a4, _b4;
        return ((_a4 = item == null ? void 0 : item.variant) == null ? void 0 : _a4.id) === ((_b4 = item2 == null ? void 0 : item2.variant) == null ? void 0 : _b4.id);
      });
      if (addedIndex !== -1 && item.price_override === acc[addedIndex]["price_override"]) {
        acc[addedIndex]["quantity"] += 1;
      } else {
        acc.push({
          quantity: 1,
          price: (_a3 = item.variant) == null ? void 0 : _a3.price,
          compare_at_price: (_b3 = item.variant) == null ? void 0 : _b3.compare_at_price,
          ...item
        });
      }
      return acc;
    }, []);
    state.bundle_target_titles = getTargetTitles();
  });
  const updateBundleById = /* @__PURE__ */ __name((bundle_id = state.bundle_target_id) => {
    var _a2, _b2, _c2, _d2;
    state.bundle_target_id = bundle_id;
    if (state.bundle_target_id || ((_a2 = state.items_added) == null ? void 0 : _a2.length)) {
      state.bundle_target = (_b2 = bundle_targets.find((target) => {
        var _a3;
        if (bundle_type === "item_count") {
          return target.id === state.bundle_target_id && target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
        } else {
          return target.id === state.bundle_target_id;
        }
      })) == null ? void 0 : _b2.settings;
      if (!state.bundle_target && (bundle_targets == null ? void 0 : bundle_targets.length)) {
        const bundle_target = (_d2 = [...bundle_targets].sort((a, b) => a.settings.target - b.settings.target).find((target) => {
          var _a3;
          if (bundle_type === "item_count") {
            return target.settings.target >= ((_a3 = state.items_added) == null ? void 0 : _a3.length);
          } else {
            return true;
          }
        })) != null ? _d2 : (_c2 = [...bundle_targets].sort((a, b) => b.settings.target - a.settings.target)) == null ? void 0 : _c2[0];
        state.bundle_target = bundle_target == null ? void 0 : bundle_target.settings;
        state.bundle_target_id = bundle_target == null ? void 0 : bundle_target.id;
      }
    }
  }, "updateBundleById");
  const handleAddToCart = /* @__PURE__ */ __name(async (action) => {
    var _a2, _b2, _c2, _d2;
    try {
      state.isAdding = true;
      const data = await _cart.add({
        items: (_a2 = state.items_added) == null ? void 0 : _a2.map((item) => {
          var _a3, _b3, _c3, _d3, _e2;
          return {
            id: (_a3 = item == null ? void 0 : item.variant) == null ? void 0 : _a3.id,
            properties: {
              _bundle_id: random_id,
              Bundle: (_b3 = state.achieved_bundle_target) == null ? void 0 : _b3.label,
              Preorder: ((_c3 = item == null ? void 0 : item.variant) == null ? void 0 : _c3.preorder) && ((_d3 = item == null ? void 0 : item.variant) == null ? void 0 : _d3.inventory_quantity) < preorder_threshold ? ((_e2 = item == null ? void 0 : item.variant) == null ? void 0 : _e2.preorder_date) ? `Shipping ${new Date(item == null ? void 0 : item.variant.preorder_date).toLocaleDateString(navigator.language, {
                month: "short",
                year: "numeric"
              })}` : "true" : void 0
            },
            quantity: 1
          };
        })
      });
      if (data.cart_error) {
        state.isAdding = false;
        return;
      }
      if (action === "add_to_cart") {
        _stores.modal.setId("modal--cart-drawer");
      }
      if (action === "checkout") {
        (_b2 = document.querySelector('[data-cart-drawer-checkout-form] button[name="checkout"]')) == null ? void 0 : _b2.click();
        state.isAdding = false;
        state.items_added_to_cart = true;
        await utils.delay(3500);
        state.items_added_to_cart = false;
        return;
      }
      state.items_added = [];
      state.bundle_target_id = (_c2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _c2.id;
      state.total_price = 0;
      state.discounted_price = 0;
      state.final_price = 0;
      state.discount_wording = "";
      state.item_count = 0;
      state.target_difference = "";
      state.bundle_target = (_d2 = bundle_targets == null ? void 0 : bundle_targets[0]) == null ? void 0 : _d2.settings;
      state.achieved_bundle_target = null;
      state.incentive_target = incentive_targets == null ? void 0 : incentive_targets[0];
      state.isAdding = false;
      state.show_mobile_details = false;
      state.items_added_to_cart = true;
      await utils.delay(3500);
      state.items_added_to_cart = false;
    } catch (error) {
    }
  }, "handleAddToCart");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    switch (show_conditionally) {
      case "always": {
        return true;
      }
      case "active_discount": {
        return !!state.active_discount_wording;
      }
      case "no_active_discount": {
        return !state.active_discount_wording;
      }
      case "target_reached": {
        return !state.target_difference;
      }
      case "target_not_reached": {
        return !!state.target_difference;
      }
    }
  }, "showConditionally");
  return {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    addToBundle,
    removeFromBundle,
    updateBundleById,
    handleAddToCart,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    showConditionally
  };
}, "initBundle");
window._sections["initBundle"] = initBundle;
